import lottie from 'lottie-web'
import { useEffect, useRef } from 'react'
import LoadingLottie from '../../assets/images/lottie_dic_book.json'

export type LoadingProps = {}

function Loading({}: LoadingProps) {
  const lottieRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (lottieRef.current) {
      lottie.loadAnimation({
        container: lottieRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: LoadingLottie,
      })
    }
  }, [lottieRef])

  return (
    <div className="loading-wrap" id="lyTimelineLoading">
      <div className="loading-box">
        <div id="loading" ref={lottieRef}></div>
        <span className="msg">잠깐만 기다려봐~</span>
      </div>
    </div>
  )
}

// const wrapper = css`
//   /* 로딩 페이지 - 로티 */
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100vh;
//   background-color: rgba(0, 0, 0, 0.5);
//   text-align: center;
//   z-index: 9999;
//   .loading-box {
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     width: 200px;
//     height: auto;
//     background: transparent;
//     transform: translate(-50%, -50%);
//   }
//   .loading {
//     width: 100%;
//   }
//   .loading-box .msg {
//     display: inline-block;
//     position: absolute;
//     bottom: 8px;
//     left: 50%;
//     transform: translate(-50%, 0);
//     width: 100%;
//     margin-top: -40px;
//     font-size: 25px;
//     color: #fff;
//   }
// `

export default Loading
